import axios from "axios";
import { base_url } from "../../Auth/BackendAPIUrl";
import { ConfigToken } from "../../Auth/ConfigToken";

export const fetchDynamicQuestionnaire = async (orderId) => {
  const res = await axios.get(
    `${base_url}/api/questionnaire/${orderId}/dynamic/`,
    ConfigToken()
  );
  return res.data;
};

export const submitDynamicQuestionnaire = async (orderId, answers, status) => {
  const res = await axios.put(
    `${base_url}/api/questionnaire/${orderId}/dynamic/`,
    { answers, status },
    ConfigToken()
  );
  return res.data;
};
